module.exports = __webpack_public_path__ + "img/makeup-mirror.7b75e33d.jpg";